export const VEHICLE_IMAGES = {
  "Toyota Hiace Commuter-2025": [
    "/images/hiace-2025/1-PHOTO-2026-04-26-01-14-33.jpg",
    "/images/hiace-2025/2-PHOTO-2026-04-26-01-14-32.jpg",
    "/images/hiace-2025/3-PHOTO-2026-04-26-01-14-30.jpg",
    "/images/hiace-2025/4-PHOTO-2026-04-26-01-14-30 2.jpg",
  ],
  "Toyota Hiace Commuter-2015": [
    "/images/hiace-2015/1-PHOTO-2026-04-26-01-14-35 2.jpg",
    "/images/hiace-2015/PHOTO-2026-04-26-01-14-27.jpg",
    "/images/hiace-2015/PHOTO-2026-04-26-01-14-36 2.jpg",
    "/images/hiace-2015/PHOTO-2026-04-26-01-14-36.jpg",
  ],
  "Toyota Tarago-2020": [
    "/images/tarago-2020/22_2451.jpg",
    "/images/tarago-2020/22_2455.jpg",
  ],
};

export function getVehicleImages(model, year) {
  const key = `${model}-${year}`;
  return VEHICLE_IMAGES[key] || null;
}
